var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-status"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-frown-o"})]),_c('div',{staticClass:"title"},[_vm._v("OOPS..404")]),_c('div',{staticClass:"text"},[_vm._v("Sorry, seems like you are in middle of nowhere.")])])
}]

export { render, staticRenderFns }